import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canListCategories } from "@/helpers/permissions";
import { canManageCategories } from "@/modules/ticket-categories/permissions";

import { ticketCategoriesRoutes } from "./routes";

export const ticketCategoriesRoute = [
  {
    path: ticketCategoriesRoutes.list,
    lazy: async () => {
      const { TicketCategoryOverviewPage } = await import("./pages/TicketCategoryOverviewPage");

      return {
        element: (
          <RequireAuth permission={canListCategories}>
            <TicketCategoryOverviewPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: ticketCategoriesRoutes.create,
    lazy: async () => {
      const { CreateTicketCategoryPage } = await import("./pages/CreateTicketCategoryPage");

      return {
        element: (
          <RequireAuth permission={canManageCategories}>
            <CreateTicketCategoryPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: ticketCategoriesRoutes.edit,
    lazy: async () => {
      const { EditTicketCategoryPage } = await import("./pages/EditTicketCategoryPage");

      return {
        element: (
          <RequireAuth permission={canManageCategories}>
            <EditTicketCategoryPage />
          </RequireAuth>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
